import { PoemCommandGroup } from './commandBar';
import { Command } from './command';
import { CSSProperties, isValidElement, cloneElement } from 'react';
import styles from './commandBar.module.css';

export interface CommandGroupProps {
  group: PoemCommandGroup;
  isCollapsed?: boolean;
}

export const CommandGroup = ({
  group,
  isCollapsed = false,
}: CommandGroupProps) => {
  const displayAsGrid = group.displayStyle === 'grid';
  return (
    <div className={styles.commandGroupWrapper} data-collapsed={isCollapsed}>
      <div
        className={
          displayAsGrid ? styles.commandGroupGrid : styles.commandGroupInline
        }
        style={
          { '--rows': Math.min(3, group.commands.length) } as CSSProperties
        }
      >
        {group.commands.map((command, index) => {
          if (isValidElement(command)) {
            return cloneElement(command, { isCollapsed, key: index } as Record<
              string,
              unknown
            >);
          }

          return (
            <Command key={index} command={command} isCollapsed={isCollapsed} />
          );
        })}
      </div>
      <div className={styles.labelArea}>
        <span>{group.label}</span>
      </div>
    </div>
  );
};
